import React from 'react'
import "./Error404.css"

const Error404 = () => {
    return (
        <div className="errorContainer">
            <h1 className="errorPage">UPS 404 Not Found</h1>
        </div>
    )
}

export default Error404